module.exports = __webpack_public_path__ + "img/blue_166.7e3c84c8.png";